import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';

type UnsupportedReceiptTypeCardProps = {
  receiptType: string;
  rejecting?: boolean;
  onReject: () => void;
};

const UnsupportedReceiptTypeCard: React.FC<UnsupportedReceiptTypeCardProps> = React.memo(({
  receiptType,
  rejecting = false,
  onReject,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        height: '100%',
        minHeight: 320,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        mt: 1.5
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 520 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={700} sx={{ mb: 1, textAlign : 'center' }}>
            Receipt Type Not Supported
          </Typography>

            <Typography variant="subtitle2" sx={{ color: 'rgba(237, 108, 2, 1)', textAlign: 'center', mb: 2 }}>
              Receipt type: <strong>{receiptType || 'unknown'}</strong>
            </Typography>
          <Button
            fullWidth
            variant="contained"
            color="warning"
            onClick={onReject}
            disabled={rejecting}
            sx={ {
              backgroundColor: '#FF0000'
            }}
          >
            {rejecting ? 'Rejecting…' : 'Reject'}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
});

UnsupportedReceiptTypeCard.displayName = 'UnsupportedReceiptTypeCard';

export default UnsupportedReceiptTypeCard;

